import type { JSX } from 'react'
import type { TextBoxColors } from 'atoms/TextBox'
import type {
  IRowContainerProps,
  SpecialRowContainerBackgroundT,
} from '../RowContainer.h'

import { CAROUSEL_PADDINGS, FIXED_INDENTS, LAYOUT, ROW_GAP } from 'vars/index'
import { RowContainer } from '../RowContainer'
import {
  CardsInRow,
  CellsAlignment,
  RowControlsType,
  RowDescriptionType,
  RowPaddings,
  SpecialRowContainerBackground,
} from '../RowContainer.h'

export interface ISpecialRowContainerTemplateProps extends IRowContainerProps {
  cardsInRow?: CardsInRow
  scrollByCardsCount?: number
  cellsAlignment?: CellsAlignment
  children?: JSX.Element[]
  gap?: ROW_GAP
  paddings?: (typeof RowPaddings)[keyof typeof RowPaddings]
  controlsType?: RowControlsType
  title?: string
  buttonTitle?: string
  descriptionType: RowDescriptionType
  description?: string
  backgroundStyle?: SpecialRowContainerBackgroundT
  titleColor?: TextBoxColors
}

export const SpecialRowContainerTemplateWithFakeCell = ({
  cardsInRow = CardsInRow.Horizontal_4,
  cellsAlignment = CellsAlignment.Start,
  selectedItem,
  children,
  gap = ROW_GAP.SIZE_10,
  paddings: _unused = RowPaddings.DEFAULT,
  controlsType = RowControlsType.inRowFluid,
  descriptionType = RowDescriptionType.CenteredWithInlineBtn,
  buttonTitle = 'See All',
  description,
  title,
  backgroundStyle = SpecialRowContainerBackground.FullWidthImage,
  verticalPaddingTop = CAROUSEL_PADDINGS.PADDING_TOP_SPECIAL_ROW,
  verticalPaddingBottom = FIXED_INDENTS.INDENT_60,
  verticalMarginTop = LAYOUT.VerticalTopSpecialRowPaddings,
  verticalMarginBottom = LAYOUT.VerticalBottomSpecialRowPaddings,
  containerVerticalGap,
  rowPosterImage,
  ...rest
}: ISpecialRowContainerTemplateProps): JSX.Element => {
  return (
    <RowContainer
      cardsInRow={cardsInRow}
      rowPosterImage={rowPosterImage}
      verticalPaddingBottom={verticalPaddingBottom}
      verticalPaddingTop={verticalPaddingTop}
      verticalMarginTop={verticalMarginTop}
      verticalMarginBottom={verticalMarginBottom}
      containerVerticalGap={containerVerticalGap}
      controlsType={controlsType}
      gap={gap}
      cellsAlignment={cellsAlignment}
      withSpecialCell={true}
      backgroundStyle={backgroundStyle}
      description={description}
      title={title}
      buttonTitle={buttonTitle}
      descriptionType={descriptionType}
      selectedItem={selectedItem}
      {...rest}
    >
      {children}
    </RowContainer>
  )
}
